.cal-day {
  border-collapse: collapse;
}

.cal-day-top {
  font-weight: 400;
  text-align: left;
  color: var(--button-text);
  padding: 2px;
  text-transform: uppercase;
}

.cal-day-day {
  width: 100%;
}

.cal-day-time00 {
  text-align: right;
  border-right: solid 1px var(--calendar-border);
  border-left: solid 1px var(--calendar-border);
  padding: 1px 5px 2px;
}

.cal-day-hour00 > td,
.cal-day-time {
  border-top: solid 1px var(--calendar-border);
  border-bottom: dashed 1px var(--calendar-border);
}

.cal-day-hour30 > td {
  border-bottom: solid 1px var(--calendar-border);
}

.cal-day-time30,
.cal-day-cell {
  border-right: solid 1px var(--calendar-border);
  border-left: solid 1px var(--calendar-border);
  height: 2.2em;
}

.cal-day-cell {
  position: relative;
}

.cal-day-daysel div {
  width: 16px;
}

.cal-day-daysel:hover {
  cursor: pointer;
  background-color: var(--hover-light);
}

.cal-day-cell > div {
  position: absolute;
  top: 0;
  z-index: 5;
  width: 100%;
}

.cal-day-add-item {
  display: none;
  margin: 0 1px 2px;
  padding: 0 4px 1px;
  position: absolute;
  top: 0;
  right: 0;
}

.cal-day-cell:hover .cal-day-add-item {
  display: block;
  cursor: pointer;
}
